import { Field, Image, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import styles from './ContentOverviewSponsors.module.css';

type ContentOverviewSponsorsProps = ComponentProps & {
	fields: {
		SponsoredTitle: Field<string>;
		SponsoredImageOne: ImageField;
		SponsoredImageTwo: ImageField;
		SponsoredImageThree: ImageField;
	};
};

export default function ContentOverviewSponsors(props: ContentOverviewSponsorsProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && (!props.fields || Object.keys(props.fields.SponsoredImageOne?.value || {}).length === 0)) {
		return <></>;
	}

	return (
		<section className="maxWidth pad">
			<div className={`${styles.ContentOverviewSponsoredContainer} maxWidth`}>
				<ContentOverviewHeaderContainer header={props.fields.SponsoredTitle?.value} />
				<div className={styles.ContentOverviewSponsoredImageContainer}>
					<Image media={props.fields.SponsoredImageOne} />
					<Image media={props.fields.SponsoredImageTwo} />
					<Image media={props.fields.SponsoredImageThree} />
				</div>
			</div>
		</section>
	);
}
